import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import authService from "../../../Components/Login/auth.service";
import {
  ContainerPage,
  TitleOfPage,
  TitlePage1,
  TitlePage2,
} from "../../../Components/Main";
import ProfileDireita from "../../../Components/ProfileDireita";
import SidebarMobile from "../../../Components/SideBar-right/SidebarMobile";
import ModalEditar from "./modalTiposDeObservacoes/modalEditarQuestao";

function ChecklistEstrutura() {
  var user = authService.getCurrentUser();
  const id = useParams<{ IdObservacaoTipo: string }>();
  sessionStorage.IdObservacaoTipoEdit = id.IdObservacaoTipo;
  interface EstruturItem {
    IdObservacaoQuestao: string;
    ogrDescricao: string;
    sbgDescricao: string;
    oqsDescricao: string;
  }
    const [modal, setModal] = useState(false)
    const toggleModal = () => {
        setModal(!modal)
    }
    const [modalOpen, setModalOpen] = useState(false)
    const [modalInfo, setModalInfo] = useState<EstruturItem | null>(null)

    function handleToggleComplete(objetos: EstruturItem) {
    setModalInfo(objetos)
    setModalOpen(true)
  }
  const [estrutura, setEstrutura] = useState<EstruturItem[]>([]);

  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
          "/api/v1/observacaoestrutura/list/" +
          id.IdObservacaoTipo
      )
      .then((response) => {
        setEstrutura(response.data);
      });
  }, []);

  const [observacaoTipo, setObservacaoTipo] = useState<any[]>([]);
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
          "/api/v1/observacaotipo/" +
          sessionStorage.IdObservacaoTipoEdit
      )
      .then((response) => {
        setObservacaoTipo(response.data);
      });
  }, []);

  // 1. Função para agrupar os dados por Grupo e SubGrupo
const dadosAgrupados = estrutura.reduce((acc: Record<string, Record<string, EstruturItem[]>>, item) => {
  const grupo = item.ogrDescricao;
  const subGrupo = item.sbgDescricao;

  if (!acc[grupo]) {
    acc[grupo] = {};
  }
  if (!acc[grupo][subGrupo]) {
    acc[grupo][subGrupo] = [];
  }
  
  acc[grupo][subGrupo].push(item);
  return acc;
}, {});

  //console.log(estrutura);

  return (
    <>
    <div>
    {modalOpen && (
    <ModalEditar setOpenModal={setModalOpen} modalInfo={modalInfo}/>
    )}
    </div>
    <div className="overlay2">
        <div className="modalPadrao-content">
            <div className="cxTituloPadrao" style={{ paddingBottom: "10px" }}>
                <h1>
                    Estrutura do Checklist: {observacaoTipo[0]?.otpDescricao}
                </h1>
                <button className="close-modal" onClick={() => { window.history.back() }}>
                    X
                </button>
            </div>
            <div style={{ 
                maxHeight: '500px',
                overflowY: "auto",
                padding: "20px",
                margin: "20px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                marginBottom: "50px" }}>
                <div className="tabelaPadrao" style={{ width: "100%", overflowX: "auto", marginLeft: "-50px", marginRight: "10px" }}>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                    <tr>
                    <th style={{ textAlign: "left" }}>Grupo</th>
                    <th style={{ textAlign: "left" }}>SubGrupo</th>
                    <th style={{ textAlign: "left" }}>Questão</th>
                    <th style={{ textAlign: "center" }}>Editar</th>
                    </tr>
                </thead>
                <tbody>
                    {Object.keys(dadosAgrupados).map((grupo) => (
                    <React.Fragment key={grupo}>
                        {Object.keys(dadosAgrupados[grupo]).map((subGrupo) => (
                        <React.Fragment key={subGrupo}>
                            {dadosAgrupados[grupo][subGrupo].map((item, index) => (
                            <tr key={item.IdObservacaoQuestao}>
                                {/* Exibe o nome do Grupo apenas na primeira linha do bloco */}
                                {index === 0 && (
                                <td 
                                    style={{ textAlign: "left", fontWeight: 'bold', verticalAlign: 'top' }} 
                                    rowSpan={dadosAgrupados[grupo][subGrupo].length}
                                >
                                    {grupo}
                                </td>
                                )}
                                
                                {/* Exibe o nome do SubGrupo apenas na primeira linha do bloco */}
                                {index === 0 && (
                                <td 
                                    style={{ textAlign: "left", fontWeight: '500', verticalAlign: 'top' }} 
                                    rowSpan={dadosAgrupados[grupo][subGrupo].length}
                                >
                                    {subGrupo}
                                </td>
                                )}

                                {/* Linha da questão */}
                                <td style={{ textAlign: "left", verticalAlign: 'top' }}>{item.oqsDescricao}</td>
                                <td style={{ textAlign: "center", verticalAlign: 'top' }} onClick={() => handleToggleComplete(item)}>
                                    <button className="btnPageGroupQuest">
                                        <i className="fas fa-edit"></i>
                                    </button>
                                </td>
                            </tr>
                            ))}
                        </React.Fragment>
                        ))}
                    </React.Fragment>
                    ))}
                </tbody>
                </table>
                </div>
            </div>
        </div>
    </div>
</>

    
  );
}

export default ChecklistEstrutura;